import React from 'react';
import styles from './GlobalMapSearch.module.css';

/**
 * Persistent hint surfacing the `/` command affordance. Rendered at the
 * bottom of the recents dropdown and the no-results state — not
 * alongside live result rows.
 */
export const CommandHintFooter: React.FC = () => (
  <div className={styles.dropdownFooter}>
    <span>
      Tip: type <span className={styles.dropdownFooterKey}>/</span> to search
      specific fields
    </span>
  </div>
);

export default CommandHintFooter;
